import { queueGroupQueryOptions } from "@/server/queues";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import _ from "lodash";

export const Route = createFileRoute("/_dashboard/queue-groups/$queueGroupId")({
  component: RouteComponent,
  beforeLoad: ({ location, params }) => {
    const routeParts = _.compact(location.pathname.split("/"));
    const isExactQueueGroupRoute =
      routeParts[routeParts.length - 2] === "queue-groups" &&
      (routeParts[routeParts.length - 1] === params.queueGroupId ||
        routeParts[routeParts.length - 1] === `${params.queueGroupId}/`);
    if (isExactQueueGroupRoute) {
      throw redirect({
        to: "/queue-groups/$queueGroupId/queues",
        params: { queueGroupId: params.queueGroupId },
      });
    }
  },
  loader: async ({ params, context }) => {
    const queryOptions = queueGroupQueryOptions(Number(params.queueGroupId));
    //We need to prefetch the query in order to get the name for the breadcrumb
    await context.queryClient.prefetchQuery(queryOptions);
    const queueGroup = context.queryClient.getQueryData(queryOptions.queryKey) as { name?: string } | undefined;

    return {
      queueGroupId: params.queueGroupId,
      crumb: queueGroup?.name,
      dehydratedState: dehydrate(context.queryClient) as any,
    };
  },
});

function RouteComponent() {
  const { dehydratedState } = Route.useLoaderData();
  return (
    <HydrationBoundary state={dehydratedState}>
      <Outlet />
    </HydrationBoundary>
  );
}
